import { render, staticRenderFns } from "./main-modal.vue?vue&type=template&id=5dbecaee&"
import script from "./main-modal.js?vue&type=script&lang=js&"
export * from "./main-modal.js?vue&type=script&lang=js&"
import style0 from "./main-modal.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VDialog})
